// @ts-nocheck
import React, { useEffect, useState } from "react";
import { Calendar, dateFnsLocalizer, Event } from "react-big-calendar";
import { format, parse, startOfWeek, getDay } from "date-fns";
import { enUS } from "date-fns/locale/en-US";
import { BsChevronRight, BsChevronLeft } from "react-icons/bs";
import { TbGavel } from "react-icons/tb";
import { IconButton, Zoom } from "@mui/material";
import "react-big-calendar/lib/css/react-big-calendar.css";
import PropertyDrawer from "./PropertyDrawer";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import PropertiesFilterHeader from "../../components/commonComponents/PropertiesFilterHeader";
import { useOutletContext } from "react-router-dom";
import Loading from "../../components/Loading";
import { Helmet } from "react-helmet";
import filterIcon from "../../assets/filterIcon.svg";
import { fetchcalenderProperties } from "../../redux/slice/calenderPropertiesSlice";
import { AppDispatch, RootState } from "../../redux/types";
import { BackButton } from "../../components/commonComponents/BackButton";
import { MyBidApi } from '../../redux/slice/mybidSlice';

// Set up the localizer for the calendar using date-fns
const locales = { "en-US": enUS };
const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});

// Type definitions for state and props
interface CustomButtonsProps {
  toolbar: any; // ideally typed properly
  onMonthChange: (start: Date, end: Date) => void;
}
interface AuctionEvent {
  title: string;
  start: string;
  end: string;
  allDay: boolean;
  resource: number;
}

export default function AuctionCalendar() {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);
  const [selectedState, setSelectedState] = useState([]);
  const [selectedCounties, setSelectedCounties] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isRemoteBiddingEnable, setIsRemoteBiddingEnable] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [selectedAuctionStatus, setSelectedAuctionStatus] = useState([]);
  const [selectedPropertyType, setSelectedPropertyType] = useState([]);
  const [filteredAuctions, setFilteredAuctions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  // States for various filters
  const [priceRange, setPriceRange] = useState({ min: null, max: null });
  const [beds, setBeds] = useState("Any");
  const [baths, setBaths] = useState("Any");
  const [lotSize, setLotSize] = useState({
    min: "No Minimum",
    max: "No Maximum",
  });
  const [squareFootage, setSquareFootage] = useState({ min: null, max: null });
  const [yearBuilt, setYearBuilt] = useState({ min: null, max: null });
  // Separate states for Occupancy
  const [generalOccupancy, setGeneralOccupancy] = useState([]);
  const [reportedVacancy, setReportedVacancy] = useState(false);
  const [isDataAvailable, setIsDataAvailable] = useState(true);
  const [events, setEvents] = useState([]);
  const [currentDayProperties, setCurrentDayProperties] = useState<any[]>([]); // Use a more flexible type for properties
  const [selectedDate, setSelectedDate] = useState<string | null>(null);
  const [futureProperties, setFutureProperties] = useState([]);
  const [currentMonth, setCurrentMonth] = useState(moment().month()); // Get current month (0-based)
  const [diffViewMonth, setDiffviewMonth] = useState(0); // Get current month (0-based
  const [currentYear, setCurrentYear] = useState(moment().year()); // Get current year
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const { investorId } = useSelector((state: RootState) => state?.user);
  const [dateRange, setDateRange] = useState({
    start: null,
    end: null
  })
  const dispatch = useDispatch<AppDispatch>()
  // Getting properties from the Redux store
  const { calenderProperties } = useSelector(
    (state) => state.calenderProperties
  );
  const isMobile = useOutletContext();
  const myBidData = useSelector((state) => state.mybid.myBidData);
  const lastFetched = useSelector((state) => state.mybid.lastFetched);
  const shouldRefetch = !lastFetched || (Date.now() - lastFetched > 5 * 60 * 1000); // 5 minutes

  const searchParams = new URLSearchParams(location.search);
  const selectedDateforMonth = searchParams.get('selectedDate');

  useEffect(() => {
    const date = selectedDateforMonth ? moment(selectedDateforMonth) : moment();
    setCurrentMonth(date.month());
    setCurrentYear(date.year());
  }, []);

  useEffect(() => {
    if (calenderProperties && calenderProperties.length > 0) {
      filterPropertiesByMonth(currentMonth, currentYear);
    } else {
      setEvents([]);
    }
  }, [calenderProperties]);
  const fetchingPropertiesMonthWise = async (start: Date, end: Date) => {
    try {
      setDateRange({
        start, end
      })
      const states = selectedState.map((state) => state.value);
      const counties = selectedCounties.map((counties) => counties.value);
      const propertyType = selectedPropertyType.map((type) => type.value);
      const auctionStatus = selectedAuctionStatus.map(
        (status) => status.value
      );

      const propertyData = {
        pageNumber,
        pageSize: 50,
        sortBy: "",
        sortDirection: "ascending",
        isRemoteBidding: isRemoteBiddingEnable,
        state: states || [],
        county: counties || [],
        auctionStatus: auctionStatus || [],
        propertyType: propertyType || [],
        occupancyStatus: generalOccupancy,
        reportVacant: reportedVacancy ? "YN_Y" : "",
        startPriceRange: priceRange.min ? parseInt(priceRange.min) : 0,
        endPriceRange: priceRange.max ? parseInt(priceRange.max) : 0,
        beds: beds === "Any" ? 0 : beds,
        baths: baths === "Any" ? 0 : baths,
        sqFtStartRange: squareFootage.min ? parseInt(squareFootage.min) : 0,
        sqFtEndRange: squareFootage.max ? parseInt(squareFootage.max) : 0,
        lotSizeEndRange:
          lotSize.min && !isNaN(lotSize.min) ? parseInt(lotSize.min) : 0,
        lotSizeStartRange:
          lotSize.max && !isNaN(lotSize.max) ? parseInt(lotSize.max) : 0,
        yearBuiltStartRange: yearBuilt.min ? parseInt(yearBuilt.min) : 0,
        yearBuiltEndRange: yearBuilt.max ? parseInt(yearBuilt.max) : 0,
      };
      const payload = {
        ...propertyData,
        startDate: moment(start).format("YYYY-MM-DD"),
        endDate: moment(end).format("YYYY-MM-DD"),
        investorId: investorId,
      };
      const response = await dispatch(fetchcalenderProperties(payload)).unwrap();

      if (response.length === 0) {
        setIsDataAvailable(false);
      } else {
        setIsDataAvailable(true);
      }
    } catch (error) {
      console.error(error)
      setError(error);
    } finally {
      setFetchLoading(false);
    }
  };
  useEffect(() => {
    const start = moment().startOf('day').toDate()
    const end = moment().endOf('month').toDate()
    fetchingPropertiesMonthWise(start, end)
  }, []);

  useEffect(() => {
    if (investorId && shouldRefetch) {
      dispatch(MyBidApi(parseInt(investorId)));
    }
  }, [investorId, shouldRefetch, dispatch]);

  const processProperties = (calenderProperties, visibleDate = moment()) => {
    const today = moment().startOf("day");
    const viewMonth = moment(visibleDate).month(); // 0-indexed
    const viewYear = moment(visibleDate).year();

    const currentDay = [];
    const futureDay = [];

    const groupedProperties = calenderProperties.reduce((acc, property) => {
      const auctionDate = moment(
        property?.srpSaleDateTime
      );
      const auctionDateStr = auctionDate.parseZone().format("YYYY-MM-DD");
      console.log(auctionDateStr)

      // Group properties by formatted auction date (YYYY-MM-DD)
      if (!acc[auctionDateStr]) {
        acc[auctionDateStr] = [];
      }
      acc[auctionDateStr].push(property);

      if (auctionDate.isSame(today, "day")) {
        currentDay.push(property);
      } else if (auctionDate.isAfter(today, "day")) {
        futureDay.push(property);
      }

      return acc;
    }, {});

    setCurrentDayProperties(currentDay);
    setFutureProperties(futureDay);

    const events = Object.keys(groupedProperties)
      .map((date) => {
        const propertiesForDate = groupedProperties[date];

        if (moment(date).isSameOrAfter(today, "day")) {
          return {
            title: `Auctions (${propertiesForDate.length})`,
            start: moment(date).toDate(),
            end: moment(date).toDate(),
            allDay: true,
            date: date,
            properties: propertiesForDate,
          };
        }
        return null;
      })
      .filter((event) => event !== null);

    setEvents(events);
  };



  const isHighlightedDate = (event) => {
    const today = moment().startOf("day");
    const eventDate = moment(event.start);
    if (eventDate.isAfter(today, "day")) {
      // Apply background color for future dates
      return {
        className: "custom-event-style", // Apply the CSS class
      };
    } else if (eventDate.isBefore(today, "day")) {
      return {
        className: "disabled-date",
      };
    }
    return {};
  };

  const isDisabledDate = (date: Date): boolean => {
    const currentDate = new Date(); // Get today's date (without time)

    // Disable past dates
    return date < currentDate;
  };

  const dayPropGetter = (date: Date) => {
    let props: any = {};
    const dateStr = moment(date).format("YYYY-MM-DD");
    const currentDayCount = currentDayProperties.filter((property) =>
      moment(property?.srpSaleDateTime).isSame(
        dateStr,
        "day"
      )
    ).length;
    const futureDayCount = futureProperties.filter((property) =>
      moment(property?.srpSaleDateTime).isSame(
        dateStr,
        "day"
      )
    ).length;    // Get the day of the month
    const dayOfMonth = date.getDate();
    const eventOnThisDay = events.find((event) =>
      moment(event.start).isSame(date, "day")
    ); // Find event for that date

    if (eventOnThisDay) {
      return isHighlightedDate(eventOnThisDay); // Return custom style for future events
    }
    // Check for disabled date and add it to the className
    if (isDisabledDate(date)) {
      props.className = props.className
        ? `${props.className} disabled-date`
        : "disabled-date";
    }

    // If the date is outside the 1st to 31st range, ensure it doesn't have any events or background
    if (dayOfMonth > 31) {
      props.style = {
        visibility: "hidden", // Hide the overflow date cells
      };
    }

    if (dayOfMonth < 1 || dayOfMonth > 31) {
      props.style = {
        visibility: "hidden", // Hide the overflow date cells (in future or past months)
      };
    }

    return props;
  };

  const eventPropGetter = (event) => {
    // const eventDate = moment(event.start); // Event's date (start of the event)

    // // Format the event date to match the format used in the groupedProperties
    // const eventDateStr = eventDate.format("YYYY-MM-DD");
    // const today = moment().startOf("day");
    // const currentDay = [];
    // const futureDay = [];

    // // Step 1: Group properties by auction date
    // const groupedProperties = calenderProperties.reduce((acc, property) => {
    //   const auctionDate = moment.parseZone(
    //     property?.srpSaleDateTime
    //   );
    //   const auctionDateStr = auctionDate.format("YYYY-MM-DD");

    //   // Group properties by formatted auction date (YYYY-MM-DD)
    //   if (!acc[auctionDateStr]) {
    //     acc[auctionDateStr] = [];
    //   }
    //   acc[auctionDateStr].push(property);

    //   // Separate properties based on today's date and future dates
    //   if (auctionDate.isSame(today, "day")) {
    //     currentDay.push(property);
    //   } else if (auctionDate.isAfter(today, "day")) {
    //     futureDay.push(property);
    //   }

    //   return acc;
    // }, {});
    // Default style if no conditions are met
    return {};
  };


  // properties -> filter the properties on the basis of the date -> then we will

  const filterPropertiesByMonth = (month, year) => {
    const visibleDate = moment({ month, year });
    processProperties(calenderProperties, visibleDate);
  };

  const toggleSidebar = (state: boolean, date: string) => {
    const today = moment().startOf("day");
    const selectedMoment = moment(date).startOf("day");

    if (!state) {
      setIsSidebarOpen(false);
      setCurrentDayProperties([]);
      setSelectedDate(null);
      // Remove the parameters when closing
      const url = new URL(window.location.href);
      url.searchParams.delete('auctionList');
      url.searchParams.delete('selectedDate');
      window.history.replaceState({}, '', url.toString());
      return;
    }

    // Check for event data for future dates
    const selectedProperties =
      events.find((event) => event.date === date)?.properties || [];

    const propertiesDates = selectedProperties.map(
      (property) => property.srpSaleDateTime
    );

    const eventForSelectedDate = events.find((event) =>
      moment(event.date).isSame(selectedMoment, 'day')
    );

    console.log(eventForSelectedDate, "eventForSelectedDate")

    if (eventForSelectedDate) {
      // Update URL based on sidebar state
      const url = new URL(window.location.href);
      if (state) {
        url.searchParams.set('auctionList', 'true');
        url.searchParams.set('selectedDate', date);
      }
      // else {
      //   url.searchParams.delete('auctionList');
      //   url.searchParams.delete('selectedDate');
      // }
      window.history.replaceState({}, '', url.toString());

      // Proceed with opening the sidebar
      setSelectedDate(date);
      setCurrentDayProperties(eventForSelectedDate.properties);
      setIsSidebarOpen(state);
    } else {
      console.log("No event data found for this future day.");
      setIsSidebarOpen(false);
      setCurrentDayProperties([]); // Clear stale data here too
      setSelectedDate(null);
      // Remove the parameter when closing
      const url = new URL(window.location.href);
      // url.searchParams.delete('auctionList');
      // url.searchParams.delete('selectedDate');
      window.history.replaceState({}, '', url.toString());
    }
  };

  useEffect(() => {
    // Check URL parameters on component mount
    const urlParams = new URLSearchParams(window.location.search);
    const auctionList = urlParams.get('auctionList');
    const selectedDateParam = urlParams.get('selectedDate');

    if (auctionList === 'true' && selectedDateParam) {
      const eventForSelectedDate = events.find((event) =>
        moment(event.date).isSame(moment(selectedDateParam), 'day')
      );

      if (eventForSelectedDate) {
        setSelectedDate(selectedDateParam);
        setCurrentDayProperties(eventForSelectedDate.properties);
        setIsSidebarOpen(true);
      }
    }
  }, [events]);
  // Custom Toolbar component
  const CustomButtons = ({ toolbar, onMonthChange }: CustomButtonsProps) => {

    const currentMoment = moment();
    const currentMonth = currentMoment.month();
    const currentYear = currentMoment.year();

    const goToBack = () => {
      const newDate = moment(toolbar.date).subtract(1, 'months');
      toolbar.onNavigate('PREV');

      const isCurrentMonth = newDate.isSame(moment(), 'month');

      const startDate = isCurrentMonth
        ? moment().startOf('day') // today’s date at midnight
        : newDate.clone().startOf('month');

      const endDate = newDate.clone().endOf('month');

      onMonthChange(startDate.toDate(), endDate.toDate());
      handleMonthChange(newDate.month(), newDate.year());
    };

    const goToNext = () => {
      const newDate = moment(toolbar.date).add(1, 'months');
      toolbar.onNavigate('NEXT');
      onMonthChange(newDate.startOf('month').toDate(), newDate.endOf('month').toDate());
    };

    const selectedMonthYear = format(toolbar.date, "MMM yyyy");
    const currentDate = moment({
      month: moment().month(),
      year: moment().year(),
    });
    const selectedDate = moment(selectedMonthYear);
    const monthsDiff = selectedDate.diff(currentDate, "months");
    const isBackButtonDisabled = monthsDiff < 1;
    const isNextButtonDisabled = monthsDiff >= 5;

    return (

      <div className="flex items-center bg-white">
        <button
          aria-label="Go to previous month"
          disabled={isBackButtonDisabled}
          onClick={goToBack}
          className="p-4"
        >
          <BsChevronLeft
            aria-label="previous-month-svg"
            className="h-5 w-5"
            color={isBackButtonDisabled ? "#9FA4AB" : "#3B3B3B"}
          />
        </button>
        <span className="font-semibold text-lg">
          {format(toolbar.date, "MMM yyyy")}
        </span>
        <button
          aria-label="Go to next month"
          disabled={isNextButtonDisabled}
          onClick={goToNext}
          className="p-4"
        >
          <BsChevronRight
            aria-label="next-month-svg"
            color={isNextButtonDisabled ? "#9FA4AB" : "#3B3B3B"}
            className="h-5 w-5"
          />
        </button>
      </div>
    );
  };

  // Custom Event component to display auction event
  const CustomEvent = ({ event }: { event: any }) => {
    const hasProxyBid = event?.properties.some(
      (property) => property?.isProxyBid === true
    );

    return <div onClick={() => toggleSidebar(true, event.date)} aria-label={`Event on ${event.date}`}>
      <div className="flex flex-col justify-start items-center pr-2">
        {hasProxyBid && (
          <div
            style={{
              backgroundColor: "#12B28C",
              borderRadius: "50%",
              width: isMobile ? 22 : 35,
              height: isMobile ? 22 : 35,
              alignSelf: isMobile ? "center" : "flex-end",
              display: "flex",
              bottom: isMobile ? 10 : 30,
              top: isMobile ? 80 : 0,
              position: "absolute",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "5px",
              padding: isMobile ? "5px" : "0px"
            }}
          >
            <TbGavel size={25} color="white" aria-label="Proxy bid placed" />
          </div>
        )}
      </div>

      {/* Title section */}
      {isMobile ? (
        <></>
      ) : (
        <div className="flex pl-3 ">
          <span className="bg-[#FF5C39] p-1 rounded-md text-sm font-medium text-center overflow-hidden whitespace-nowrap text-ellipsis">
            {event.title}
          </span>
        </div>
      )}
    </div>
  };

  const onMonthChange = (start, end) => {
    console.log("Start of month:", start);
    console.log("End of month:", end);
    fetchingPropertiesMonthWise(start, end)
  }
  const minDate = moment({ year: currentYear, month: currentMonth })
    .startOf("month")
    .toDate();
  const maxDate = moment({ year: currentYear, month: currentMonth })
    .endOf("month")
    .toDate();

  return (
    <>
      <div className='flex justify-start items-center'>
      </div>
      <div
        className={`w-[100%] mt-0 sm:mt-10 md:mt-1 ${isMobile ? "-mr-0 -ml-0" : "-mr-5 -ml-2"
          }`}
      >
        <Helmet>
          <title>xBid | Auction Calendar</title>
          <meta
            name="description"
            content="View and manage your proxy bids for upcoming auctions. Track live auctions and update your bids in real-time."
          />
        </Helmet>
        <span
          className="font-semibold text-[20px] sm:text-[20px] md:text-[22px] leading-[39px] text-[#3B3B3B] sm:pl-3"
          role="heading"
        >
          Auction Calendar
        </span>
        <PropertiesFilterHeader
          setLoading={setLoading}
          setIsFilterOpen={setIsFilterOpen}
          isFilterOpen={isFilterOpen}
          setSelectedPropertyType={setSelectedPropertyType}
          selectedState={selectedState}
          selectedAuctionStatus={selectedAuctionStatus}
          setSelectedAuctionStatus={setSelectedAuctionStatus}
          selectedPropertyType={selectedPropertyType}
          setSelectedCounties={setSelectedCounties}
          setSelectedState={setSelectedState}
          setIsRemoteBiddingEnable={setIsRemoteBiddingEnable}
          isRemoteBiddingEnable={isRemoteBiddingEnable}
          selectedCounties={selectedCounties}
          generalOccupancy={generalOccupancy}
          baths={baths}
          setBaths={setBaths}
          setReportedVacancy={setReportedVacancy}
          setGeneralOccupancy={setGeneralOccupancy}
          reportedVacancy={reportedVacancy}
          setPriceRange={setPriceRange}
          priceRange={priceRange}
          beds={beds}
          setBeds={setBeds}
          lotSize={lotSize}
          setLotSize={setLotSize}
          squareFootage={squareFootage}
          setSquareFootage={setSquareFootage}
          yearBuilt={yearBuilt}
          setYearBuilt={setYearBuilt}
          headertitle="Search properties in"
          dateRange={dateRange}
          isPropertyTab
        />
        {isMobile && (
          <div className=" mx-4 flex my-4 justify-end items-center">
            <div
              className="flex gap-x-1"
              onClick={() => setIsFilterOpen((prev) => !prev)}
            >
              <img src={filterIcon} alt="open filter" aria-label="Open filters" />{" "}
              <p className="underline"> Filters</p>
            </div>
          </div>
        )}
        <Calendar
          localizer={localizer}
          events={events}
          startAccessor="start"
          endAccessor="end"
          style={{ height: isMobile ? 480 : 600, Zoom: "1 !important" }}
          components={{
            toolbar: (toolbar) => CustomButtons({ toolbar, onMonthChange }),
            event: CustomEvent
          }}
          views={["month", "day"]}
          defaultView="month"
          defaultDate={selectedDateforMonth ? new Date(selectedDateforMonth) : new Date()}
          min={minDate}
          max={maxDate}
          dayPropGetter={dayPropGetter}
          // eventPropGetter={eventPropGetter}
          onSelectSlot={(e) => {
            toggleSidebar("slots:-", moment(e.start).format("YYYY-MM-DD"));
          }}
          onSelecting={(slot) => false}
          selectable={true}
        />
        <div className="mt-4 flex justify-end">
          <div className="bg-[#12B28C40] flex items-center justify-between gap-x-2 rounded-full pr-3 pl-1 py-2">
            <div
              style={{
                backgroundColor: "#12B28C",
                borderRadius: "50%",
                width: 40,
                height: 40,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <TbGavel size={20} color="white" aria-label="proxy-bid-svg" />
            </div>
            <span className="text-[#3B3B3B] font-medium leading-[24px] text-[16px]">
              Proxy Bids Placed
            </span>
          </div>

          <PropertyDrawer
            todaysProperties={currentDayProperties}
            selectedDate={selectedDate}
            isOpen={isSidebarOpen}
            toggleSidebar={toggleSidebar}
            futureProperties={futureProperties}
          />
        </div>
      </div>
    </>
  );
}
